const localeByCountry = {
  // AF: 'prs-AF', // "Afghanistan - Dari",
  AF: 'ps-AF', // "Afghanistan - Pashto",
  AL: 'sq-AL', // "Albania - Albanian",
  DZ: 'ar-DZ', // "Algeria - Arabic",
  AR: 'es-AR', // "Argentina - Spanish",
  AM: 'hy-AM', // "Armenia - Armenian",
  AU: 'en-AU', // "Australia - English",
  AT: 'de-AT', // "Austria - German",
  AZ: 'az-AZ', // "Azerbaijan - Azeri (Cyrillic)",
  // AZ: "az-AZ", // "Azerbaijan - Azeri (Latin)",
  BH: 'ar-BH', // "Bahrain - Arabic",
  BD: 'bn-BD', // "Bangladesh - Bengali",
  BY: 'be-BY', // "Belarus - Belarusian",
  BE: 'nl-BE', // "Belgium - Dutch",
  BZ: 'en-BZ', // "Belize - English",
  VE: 'es-VE', // "Bolivarian Republic of Venezuela - Spanish",
  BO: 'es-BO', // "Bolivia - Spanish",
  BA: 'bs-BA', // "Bosnia and Herzegovina - Bosnian (Cyrillic)",
  // BA: "bs-BA", // "Bosnia and Herzegovina - Bosnian (Latin)",
  BR: 'pt-BR', // "Brazil - Portuguese",
  BN: 'ms-BN', // "Brunei Darussalam - Malay",
  BG: 'bg-BG', // "Bulgaria - Bulgarian",
  KH: 'km-KH', // "Cambodia - Khmer",
  CA: 'en-CA', // "Canada - English",
  // 29: "en-029", // "Caribbean - English",
  CL: 'es-CL', // "Chile - Spanish",
  CO: 'es-CO', // "Colombia - Spanish",
  CR: 'es-CR', // "Costa Rica - Spanish",
  HR: 'hr-HR', // "Croatia - Croatian",
  CZ: 'cs-CZ', // "Czech Republic - Czech",
  DK: 'da-DK', // "Denmark - Danish",
  DO: 'es-DO', // "Dominican Republic - Spanish",
  EC: 'es-EC', // "Ecuador - Spanish",
  EG: 'ar-EG', // "Egypt - Arabic",
  SV: 'es-SV', // "El Salvador - Spanish",
  EE: 'et-EE', // "Estonia - Estonian",
  ET: 'am-ET', // "Ethiopia - Amharic",
  FO: 'fo-FO', // "Faroe Islands - Faroese",
  FI: 'fi-FI', // "Finland - Finnish",
  FR: 'fr-FR', // "France - French",
  GE: 'ka-GE', // "Georgia - Georgian",
  DE: 'de-DE', // "Germany - German",
  GR: 'el-GR', // "Greece - Greek",
  GL: 'kl-GL', // "Greenland - Greenlandic",
  GT: 'es-GT', // "Guatemala - Spanish",
  HN: 'es-HN', // "Honduras - Spanish",
  HK: 'zh-HK', // "Hong Kong S.A.R. - Chinese (Traditional) Legacy",
  HU: 'hu-HU', // "Hungary - Hungarian",
  IS: 'is-IS', // "Iceland - Icelandic",
  // IN: "as-IN", // "India - Assamese",
  // IN: "bn-IN", // "India - Bengali",
  IN: 'en-IN', // "India - English",
  // IN: "gu-IN", // "India - Gujarati",
  // IN: "hi-IN", // "India - Hindi",
  // IN: "kn-IN", // "India - Kannada",
  // IN: "kok-IN", // "India - Konkani",
  // IN: "ml-IN", // "India - Malayalam",
  // IN: "mr-IN", // "India - Marathi",
  // IN: "or-IN", // "India - Oriya",
  // IN: "pa-IN", // "India - Punjabi",
  // IN: "sa-IN", // "India - Sanskrit",
  // IN: "ta-IN", // "India - Tamil",
  // IN: "te-IN", // "India - Telugu",
  ID: 'id-ID', // "Indonesia - Indonesian",
  IR: 'fa-IR', // "Iran - Persian",
  IQ: 'ar-IQ', // "Iraq - Arabic",
  IE: 'en-IE', // "Ireland - English",
  PK: 'ur-PK', // "Islamic Republic of Pakistan - Urdu",
  IL: 'he-IL', // "Israel - Hebrew",
  IT: 'it-IT', // "Italy - Italian",
  JM: 'en-JM', // "Jamaica - English",
  JP: 'ja-JP', // "Japan - Japanese",
  JO: 'ar-JO', // "Jordan - Arabic",
  KZ: 'kk-KZ', // "Kazakhstan - Kazakh",
  KE: 'sw-KE', // "Kenya - Kiswahili",
  KR: 'ko-KR', // "Korea - Korean",
  KW: 'ar-KW', // "Kuwait - Arabic",
  KG: 'ky-KG', // "Kyrgyzstan - Kyrgyz",
  LA: 'lo-LA', // "Lao P.D.R. - Lao",
  LV: 'lv-LV', // "Latvia - Latvian",
  LB: 'ar-LB', // "Lebanon - Arabic",
  LY: 'ar-LY', // "Libya - Arabic",
  LI: 'de-LI', // "Liechtenstein - German",
  LT: 'lt-LT', // "Lithuania - Lithuanian",
  LU: 'lb-LU', // "Luxembourg - Luxembourgish",
  MO: 'zh-MO', // "Macao S.A.R. - Chinese (Traditional) Legacy",
  MK: 'mk-MK', // "Macedonia (FYROM) - Macedonian (FYROM)",
  // MY: "en-MY", // "Malaysia - English",
  MY: 'ms-MY', // "Malaysia - Malay",
  MV: 'dv-MV', // "Maldives - Divehi",
  MT: 'mt-MT', // "Malta - Maltese",
  MX: 'es-MX', // "Mexico - Spanish",
  MN: 'mn-MN', // "Mongolia - Mongolian (Cyrillic)",
  ME: 'sr-ME', // "Montenegro - Serbian (Cyrillic)",
  // ME: "sr-ME", // "Montenegro - Serbian (Latin)",
  MA: 'ar-MA', // "Morocco - Arabic",
  NP: 'ne-NP', // "Nepal - Nepali",
  NL: 'nl-NL', // "Netherlands - Dutch",
  NZ: 'en-NZ', // "New Zealand - English",
  NI: 'es-NI', // "Nicaragua - Spanish",
  NG: 'ha-NG', // "Nigeria - Hausa (Latin)",
  // NG: "ig-NG", // "Nigeria - Igbo",
  // NG: "yo-NG", // "Nigeria - Yoruba",
  NO: 'nb-NO', // "Norway - Norwegian (Bokmal)",
  OM: 'ar-OM', // "Oman - Arabic",
  PA: 'es-PA', // "Panama - Spanish",
  PY: 'es-PY', // "Paraguay - Spanish",
  CN: 'zh-CN', // "People's Republic of China - Chinese (Simplified) Legacy",
  PE: 'es-PE', // "Peru - Spanish",
  PL: 'pl-PL', // "Poland - Polish",
  PT: 'pt-PT', // "Portugal - Portuguese",
  MC: 'fr-MC', // "Principality of Monaco - French",
  PR: 'es-PR', // "Puerto Rico - Spanish",
  QA: 'ar-QA', // "Qatar - Arabic",
  PH: 'fil-PH', // "Philippines - Filipino",
  // PH: "en-PH", // "Republic of the Philippines - English",
  RO: 'ro-RO', // "Romania - Romanian",
  RU: 'ru-RU', // "Russia - Russian",
  RW: 'rw-RW', // "Rwanda - Kinyarwanda",
  SA: 'ar-SA', // "Saudi Arabia - Arabic",
  // SA: 'en-SA', // "Saudi Arabia - Arabic",
  SN: 'wo-SN', // "Senegal - Wolof",
  RS: 'sr-RS', // "Serbia - Serbian (Cyrillic)",
  // RS: "sr-RS", // "Serbia - Serbian (Latin)",
  CS: 'sr-CS', // "Serbia and Montenegro (Former) - Serbian (Cyrillic)",
  // CS: "sr-CS", // "Serbia and Montenegro (Former) - Serbian (Latin)",
  // SG: "zh-SG", // "Singapore - Chinese (Simplified) Legacy",
  SG: 'en-SG', // "Singapore - English",
  SK: 'sk-SK', // "Slovakia - Slovak",
  SI: 'sl-SI', // "Slovenia - Slovenian",
  // ZA: "af-ZA", // "South Africa - Afrikaans",
  ZA: 'en-ZA', // "South Africa - English",
  // ZA: "xh-ZA", // "South Africa - isiXhosa",
  // ZA: 'zu-ZA', // "South Africa - isiZulu",
  // ZA: "nso-ZA", // "South Africa - Sesotho sa Leboa",
  // ZA: "tn-ZA", // "South Africa - Setswana",
  ES: 'es-ES', // "Spain - Spanish",
  LK: 'si-LK', // "Sri Lanka - Sinhala",
  SE: 'sv-SE', // "Sweden - Swedish",
  CH: 'de-CH', // "Switzerland - German",
  SY: 'ar-SY', // "Syria - Arabic",
  TW: 'zh-TW', // "Taiwan - Chinese (Traditional) Legacy",
  TJ: 'tg-TJ', // "Tajikistan - Tajik (Cyrillic)",
  TH: 'th-TH', // "Thailand - Thai",
  TT: 'en-TT', // "Trinidad and Tobago - English",
  TR: 'tr-TR', // "Turkey - Turkish",
  TM: 'tk-TM', // "Turkmenistan - Turkmen",
  AE: 'ar-AE', // "U.A.E. - Arabic",
  UA: 'uk-UA', // "Ukraine - Ukrainian",
  GB: 'en-GB', // "United Kingdom - English",
  US: 'en-US', // "United States - English",
  UY: 'es-UY', // "Uruguay - Spanish",
  UZ: 'uz-UZ', // "Uzbekistan - Uzbek (Cyrillic)",
  // UZ: "uz-UZ", // "Uzbekistan - Uzbek (Latin)",
  VN: 'vi-VN', // "Vietnam - Vietnamese",
  YE: 'ar-YE', // "Yemen - Arabic",
  ZW: 'en-ZW', // "Zimbabwe - English",
};

export { localeByCountry };
